export function IniialState() {
    return {
        trendInsightsDataApi: {
            isProcessing: false,
            data: null,
            error: false,
            message: ''
        },
    };
}